export default {
  day: 'd',
  hour: 'h',
  min: 'm',
  sesc: 'seconds',
  cancel: 'cancel',
  confirm: 'confirm',
  per_sale: { 
    title: 'The Public Sale phase ends on {days} days {hours} hours {mins} minutes {secs} seconds',
    title1: 'Participating in Public Sale requires KYC first',
    text: 'Buy DLC',
    text1: 'Participate in KYC'
  },
  meau: {
    nav1: 'What is DeepLink? ',
    nav2: 'How to buy? ',
    nav3: 'White Paper',
    nav4: 'PITCH DECK',
    nav5: 'FAQ',
    nav6: 'Reasearch',
    add: 'Address:',
    link: 'Connect wallet'
  },
  home: {
    intro: {
      title: 'DeepLink Public Sale',
      text: 'There is still time left before the start of Public Sale',
      text1: 'Currently KYC has started',
      tip: 'Please ensure that Know Your Customer (KYC) verification is completed prior to purchasing  (DLC) Tokens.'
    },
    desc: {
      title: 'Deeplink comprises two components: the DeepLink Protocol and Deeplink Software. ',
      left: {
        text: 'Each of these components utilizes the DeepLink token for payment',
        text1: 'DeepLink Protocol is a decentralized AI cloud gaming protocol,',
        text2: 'Combining AI and blockchain technology to provide ultra-low latency game rendering technology. DeepLink Software is a game remote control software and cloud gaming platform developed based on DeepLink Protocol. Based on DeepLink Protocol, there are also cloud Internet cafe platforms and blockchain Cloud game all-in-one machine, blockchain cloud game handheld machine and other products',
        text3: '100% Secure & Verified',
        btn1: 'Introduction to DeepLink Protocol',
        btn2: 'Introduction to DeepLink Software',
      },
      right: {
        text1: 'Public Sale is in progress',
        text1_1: 'KYC in progress',
        // text2: 'DLC price: 1DLC={price}USDT, remaining {days} days {hour} hours and {min} minutes',
        text2: 'DLC price: 1DLC={price}USDT',
        text3: 'The {pre_num}th Public Sale has ended',
        text4: 'Waiting for the {pre_num1}th opening, please perform KYC verification in advance',
        text5: 'Public Sale is about to begin',
        text6: 'Please complete the Know Your Customer (KYC) process before participating in the public sale. Thank you for your cooperation.',
        process: '{process}% completed',
        btn1: 'Participate in KYC certification',
        text7_1: 'The current wallet KYC is under review, please wait',
        text7_2: 'Current wallet KYC review passed!',
        text7_3: 'The current wallet KYC review has failed, please resubmit! ',
        text7_4: 'The current wallet KYC has not been submitted',
        btn2: 'Purchase DLC TOKEN',
        btn3: '5% recommended link',
        btn3_1: '10% recommended link',
        btn3_2: '15% recommended link',
        btn3_3: '20% recommended link'
      },
      success: 'Link copied to clipboard',
      error1: 'Please connect to the wallet first to get the exclusive invitation code to win rewards',
      error2: 'The wallet is not connected, please connect the wallet first'
    },
    rule: {
      title: 'Rules Description',
      text1: "KYC verification is mandatory, requiring submission of identification documents such as ID cards, passports, or driver's licenses. Residents of Singapore, China, the United States, South Korea, and certain other countries are ineligible to participate in the IDO.",
      text2: 'Following the conclusion of the Public Sale, DLC will be listed on the DEX exchange within 7 days and on the CEX exchange within 15 days.',
      text3: 'A purchase of 20,000,000 DLC qualifies for a complimentary DeepLink home GPU gaming mining machine valued at $1500. This offer is exclusive to Japan and Europe, with delivery details communicated via email.',
      text3_btn: 'Learn about home GPU gaming miners',
      text4: 'The Public Sale will close 72 hours after launch, with each DLC priced at 0.003 USDT. 40% of the tokens will remain unlocked, while the remaining 60% will unlock progressively starting from August 31, 2024.',
      text5: 'Public Sale is divided into 5 times,',
      table: {
        table1_text1: 'Opening hours, 24 hours each time',
        table1_text2: '2024/04/04',
        table1_text3: '2024/04/04',
        table1_text4: '2024/04/04',
        table1_text5: '2024/04/04',
        table1_text6: '2024/04/04',
        table2_text1: 'Number of DLCs',
        table2_text2: '10,002,000 DLC',
        table2_text3: '10,002,000 DLC',
        table2_text4: '10,002,000 DLC',
        table2_text5: '10,002,000 DLC',
        table2_text6: '10,002,000 DLC',
        table3_text1: 'DLC price (USDT)',
        table3_text2: '0.002',
        table3_text3: '0.002',
        table3_text4: '0.002',
        table3_text5: '0.002',
        table3_text6: '0.002',
        table4_text1: 'Amount',
        table4_text2: '502,000 USDT',
        table4_text3: '502,000 USDT',
        table4_text4: '502,000 USDT',
        table4_text5: '502,000 USDT',
        table4_text6: '502,000 USDT'
      }
    },
    ecology: {
      title: 'DeepLink Protocol Ecosystem Overview',
      block1_title: 'DeepLink Software',
      block1_text1: 'The core function of DeepLink software is remote control and cloud gaming platform',
      block1_text2: 'The DeepLink Protocol encompasses both the DeepLink Protocol and DeepLink Software. At its core, DeepLink Software offers remote control and cloud gaming capabilities, enabling users to engage in remote gaming, work remotely, and access cloud-based gaming services. Presently, the software boasts a global user base spanning 110 countries, with over 400,000 downloads and the creation of more than 200,000 wallets worldwide.',
      block1_btn1: 'Learn about DeepLink software',
      block2_title: 'Cloud Internet Cafe and Cloud E-Sports',
      block2_text1: "Cloud Internet Cafe represents an innovative model for internet cafes and e-sports services, leveraging DeepLink Protocol's ultra-low latency rendering technology.",
      block2_text2: "In this setup, games and applications reside on cloud GPU servers rather than local computers, allowing users to access and play games via cloud services without the need for high-performance local GPU hosts. Deployment of cloud Internet cafes based on DeepLink technology is underway in several countries, including South Korea, China, Japan, Vietnam, the Philippines, and India, with participation from developers such as HYCONS, ZESTCLOUD, GLOWSTEAM, and TIKEREN, with operational examples already established in South Korea.",
      block2_btn1: 'View video',
      block2_btn2: 'Understand the cloud Internet cafe',
      block3_title: 'Blockchain cloud game all-in-one machine',
      block3_text1: 'What is a cloud gaming all-in-one machine? ',
      block3_text2: "The blockchain cloud gaming all-in-one machine represents a leap in gaming hardware, offering high FPS refresh rates for a seamless e-sports gaming experience. Developed by HKC Group, the TIKEREN cloud gaming all-in-one machine utilizes DeepLink's ultra-low latency rendering technology to connect to cloud GPU servers in real-time, enhancing game rendering performance. ",
      block3_btn1: 'Understand the blockchain cloud game all-in-one machine',
      block4_title: 'Blockchain Cloud Game Handheld Console',
      block4_text1: 'What is a cloud gaming console? ',
      block4_text2: "The cloud gaming console, built on DeepLink's ultra-low latency rendering technology, presents a cost-effective alternative to traditional handheld consoles while delivering a smooth 3A gaming experience. By connecting to cloud GPU servers for real-time game rendering, it reduces console costs by 70%.",
      block4_btn1: 'Understand the blockchain cloud game console'
    },
    coverage: {
      title: 'DeepLink global user distribution map',
      text: 'Total number of DeepLink users:'
    },
    track: {
      title: 'DeepLink Protocol is a combined track of DePIN+AI+Game',
       text: 'Belongs to the current popular areas of the blockchain industry',
       block1_title: 'How big is the market size of DeepLink? ',
       block1_text: "One of the functions of DeepLink can be understood as decentralized XBOX and PlayStation. As of 2023, global sales of Sony's PS5 have reached 50 million units, Xbox Series X{'|'}S has reached 30 million units, and the total sales of PS and Xbox With more than 200 million units, the high-end 3A game market is huge.",
       block2_title: 'DeepLink, like XBOX and PlayStation, serves high-end 3A gamers, but the business model is completely different',
       block2_text: 'DeepLink gamers do not need to buy high-end game consoles themselves. They only need to download DeepLink software or buy a blockchain cloud game all-in-one machine or a blockchain cloud game handheld console. Players can get the same 3A gaming experience as XBOX and PlayStation, but save 80% of the hardware cost. ',
       block3_title: 'The miner provides a high-end 3A game console. The host is a Windows system and is compatible with all Windows 3A games. ',
       block3_text: "Miners' game consoles can be placed at home or in data centers. Xbox and PlayStation consoles can only be used by themselves and cannot be rented to others, so the usage efficiency is very low and there is a lot of waste of resources. DeepLink's game mining machine can be shared with anyone, thereby improving the utilization of hardware resources and bringing about a new business model. ",
       block4_title: 'Miners provide game mining machines and can receive DLC token rewards',
       block4_text: 'Thus stimulating more miners to provide game mining machines, users need to pay DLC Token to purchase game time, thereby expanding the use scenarios of DLC and the number of currency holders, with the potential user scale exceeding 1 billion people. ',
      table: {
        table1_text1: 'Detailed comparison',
        table1_text2: 'Deep Link',
        table1_text3: 'Xbox',
        table1_text4: 'PS5',
        table2_text1: 'Play 3A games',
        table2_text2: 'Users do not need to purchase hardware, only need to download DeepLink software',
        table2_text3: 'Users need to purchase hardware',
        table2_text4: 'Users need to purchase hardware',
        table3_text1: 'Game console',
        table3_text2: 'You can rent it to earn $DLC, you can rent it for more than 12 hours a day, and you can get your money back in 10 months',
        table3_text3: 'You can only use it yourself and cannot rent it out. There is a waste of hardware resources if you use it for 2-4 hours a day',
        table3_text4: 'You can only use it yourself and cannot rent it out. There is a waste of hardware resources if you use it for 2-4 hours a day',
        table4_text1: 'Handheld',
        table4_text2: 'Supported, can connect to any hardware',
        table4_text3: 'No dedicated handheld console',
        table4_text4: 'Supported, can only connect to PS5',
        table5_text1: 'Cloud gaming all-in-one machine',
        table5_text2: 'Support',
        table5_text3: 'Not supported',
        table5_text4: 'Not supported',
        table6_text1: 'Cloud Internet Cafe',
        table6_text2: 'Support',
        table6_text3: 'Not supported',
        table6_text4: 'Not supported'
      },
      btn1: 'DeepLink Software',
      btn2: 'DeepLink Protocol',
      btn3: 'Team Introduction',
      btn4: 'Economic Model'
    },
    faqs: {
      title: 'FAQS',
      text: 'You may have questions, we have answers. ',
      ques_title1: '1.What is a Public Sale?',
      ques_text1: 'During a Public Sale, a limited quantity of tokens is sold at a certain price to those who wish to participate early. This is a great opportunity to become a part of DeepLink before the actual token issuance. By participating in the Public Sale, you can purchase the token at an early bird price before it is publicly issued. Therefore, the Public Sale can be considered a potential opportunity to buy the tokens before they are circulated and listed on exchanges.',
      ques_title2: '2.Why are we conducting a Public Sale?',
      ques_text2_1: 'We are holding a Public Sale to build a strong $DLC holder community, improve our platform, raise funds, and attract more gamers into our ecosystem.',
      ques_text2_2: 'The funds raised during the Public Sale will be continually reinvested in DeepLink products, introduce new features, and expand our user base through marketing activities. This will enable us to execute our marketing strategy before the $DLC Token is issued.',
      ques_text2_3: 'Our goal is to have 1,000,000,000 people use DeepLink, which will create massive usage scenarios for the $DLC Token and ensure its long-term success. $DLC Token will be listed on DEX and CEX exchanges, further driving the growth of the DeepLink ecosystem.',
      ques_text2_4: 'Join the DeepLink Public Sale now and become a part of DeepLink!',
      ques_title3: '3.What is the difference between DeepLink Protocol and DeepLink Software?',
      ques_text3_1: 'DeepLink Protocol is a decentralized AI cloud gaming protocol that combines AI and blockchain technology to provide ultra-low latency game rendering technology.',
      ques_text3_2: 'DeepLink Software is a game remote control software and cloud gaming platform developed based on DeepLink Protocol.',
      ques_text3_3: 'Other products developed based on DeepLink Protocol include a cloud eSports internet café platform, a blockchain cloud gaming console, and a blockchain cloud gaming handheld device, among others.',
      ques_title4: '4.What is innovative about DeepLink Protocol?',
      ques_text4: 'DeepLink addresses core difficulties in the cloud gaming industry through blockchain and AI technologies, attracting miners and idle GPU machines with a token incentive mechanism and solving two key challenges in the cloud gaming industry. AI technology is used to enhance game graphics and user experience.',
      ques_title5: '5.What is $DLC Token?',
      ques_text5: '$DLC Token is the unique payment voucher within the DeepLink ecosystem. Users need to pay $DLC Token to purchase cloud gaming time, rent cloud gaming computers, buy License authorizations, etc.',
      ques_title6: '6.Who are the target customers of DeepLink Protocol?',
      ques_text6_1: '1) AAA game companies: Assisting AAA games to transform into cloud games, allowing them to run on any low-end device, including mobile phones, and helping to increase the user base of AAA games by more than tenfold.',
      ques_text6_2: '2) Internet cafes and eSports hotels: Assisting traditional internet cafes in upgrading to cloud cafes, reducing hardware investment by over 80% and tripling net profits in four years.',
      ques_text6_3: '3) Cloud gaming console manufacturers: Integrating DeepLink Protocol allows for playing AAA games with low-end CPU configurations and high-end game screens, helping players save 80% on hardware investments.',
      ques_text6_4: '4) Cloud gaming handheld device manufacturers: Manufacturers integrating DeepLink Protocol offer handhelds at 30% of the cost of traditional handhelds, with gaming performance more than five times better.',
      ques_title7: '7.Who are the target customers of DeepLink Software?',
      ques_text7: 'They are the 3 billion potential individual gamers worldwide, allowing gamers to enjoy high-end AAA games on mobile phones, low-performance computers, Macs, and TVs.',
      ques_title8: '8.Does it have a vesting period?',
      ques_text8: '40% of the purchased DLC Tokens are unlocked, and 60% will start unlocking around August 31, 2024, over 150 days, unlocking 10% every 30 days.',
      ques_title9: '9.How to purchase $DLC?',
      ques_text9: 'First, participate in KYC, submit personal information, and once verified, you can participate in the purchase of $DLC when the Public Sale starts.'
    },
    buy: {
      title: 'How to buy?',
      step1: 'Step 1:',
      step1_text: 'Connect your wallet: Use Metamask or Trust Wallet to connect your wallet in seconds',
      step2: 'Step 2:',
      step2_text: 'Confirm Transaction: You can buy $DLC with USDT, ETH and BNB.',
      step3: 'Step 3:',
      step3_text: 'Claim Tokens: Congratulations! You can claim your $DLC after the Public Sale ends.',
      btn1: 'Need help',
      btn2: 'Buy DLC', 
    },
    potential: {
      title: 'Growth Potential', 
      text1_1: 'The market value of multiple tokens on the DePIN track has continued to grow after being listed on the exchange',
      text1_2: '$ 888',
      text1_3: '$ 2288',
      text1_4: '$ 5888',
      text1_5: '$ 12888',
      text2: "DeepLink Software's potential user base exceeds 1 billion, which will bring a large number of web2 users into the web3 world, and the potential holders of $DLC exceed 1 billion people. ",
      text3: 'There are more than 200,000 e-sports Internet cafes in the world. In the future, more than 50% of traditional Internet cafes will be transformed into cloud Internet cafes. Cloud Internet cafe technology has broad application prospects. Each cloud Internet cafe needs to use $DLC for payment, bringing $DLC Used extensively. ',
      text4: 'Referring to the sales volume of XBOX and PS5, the number of users purchasing blockchain cloud game all-in-one consoles and blockchain cloud game handheld consoles will exceed 100 million, which will bring huge value to $DLC. '
    },
    report: {
      title: 'DeepLink Media Report'
    },
    prompt: {
      title: 'Explanation tips',
      text1: 'DeepCloudX.PTE.LTD operates the deeplink.cloud website (the "Platform"). ',
      text2: 'By using this platform, you accept our Terms of Service, Privacy Policy, Cookie Policy and DLC Token Sale Agreement. Cryptocurrencies may not be regulated in your jurisdiction. The value of cryptocurrencies may rise or fall. Profits may be affected by capital gains or other taxes applicable in your jurisdiction. Nothing on this website should be construed as an offer or recommendation to buy, sell or invest. You are solely responsible for determining whether any purchase or related transaction is suitable for you based on your personal objectives, financial situation and risk tolerance. ',
      text3: 'You should consult trusted, licensed legal professionals and advisors for legal, tax, insurance or business advice. DLC does not guarantee any performance, results or capital returns for any cryptocurrencies on this website. By accessing this website and any of its pages, you agree to be bound by the DLC Sales Agreement. Purchasing cryptocurrency involves risks and may result in partial or total loss. ',
    }
  },
  dialog1: {
    title: 'Submit KYC information',
    text1: 'Upload identity information:',
    text2: 'Upload handheld identity information:',
    text3: "The front information of your ID card, passport or driver’s license",
    text4: 'Need to clearly see the front face and identity information',
    text5: 'Quantity requested to purchase DLC:',
    text6: 'Certified wallet address:',
    text7: '1000 DLC will be rewarded after passing the KYC certification, and the DLC locked in the Public Sale will also be sent to this wallet address',
    text7_1: 'Only this address can purchase DLC if it passes KYC verification and cannot be an exchange address.',
    text8: 'Where to create the DLC wallet address of the DBC chain? ',
    text9: 'or',
    text10: 'Enter email address:',
    text11: 'Get verification code',
    text12: 'Enter verification code:',
    text13: 'Retrieve in {secs} seconds',
    text14: '(The maximum amount is 20,000,000 DLC. At the beginning of the Public Sale, only the amount that has passed KYC certification can be purchased)',

    success1: 'Verification code has been sent!',
    success2: 'Submission successful',
    error1: 'You must select an image file!',
    error2: 'Image file cannot be empty!',
    error3: 'Username cannot be empty!',
    error4: 'Wallet address cannot be empty!',
    error5: 'The mailbox cannot be empty!',
    error6: 'Please enter the correct email address!',
    error7: 'Verification code cannot be empty!',
    error8: 'Verification code failed to be sent, please try again later! ',
    error9: 'Add failed',
    error10: 'Verification code error, please try again',
    error11: 'Failed to query email information',
    error12: 'The purchase quantity cannot be greater than 20,000,000',
    error13: 'Verification code timed out, please obtain again',
    error14: 'The information was submitted successfully, but the confirmation email failed.',
    error15: "If you don't receive the email, please check if it was placed in spam"
  },
  dialog2: {
    title: 'Buy DLC',
    text1: 'Quantity requested to purchase DLC:',
    text2: 'A minimum purchase of 150,000 DLC is required',
    text3: 'Select payment currency:',
    text4: 'Enter the DLC wallet address of the DBC chain:',
    text5: 'The locked DLC will be transferred to this wallet address. Please confirm the correctness of the wallet address to prevent not receiving the DLC!',
    text6: 'Where to create the DLC wallet address of the DBC chain? ',
    text7: 'or',
    text8: 'Equivalent USDT:',
    text9: 'Select payment method:',
    text9_1: 'Currently connected wallet payment',
    text9_2: 'Scan QR code to pay',

    error1: 'The number of DLC cannot be empty',
    error2: 'Please enter a number',
    error3: 'The entered number must be greater than 150000',
    error4: 'Wallet address cannot be empty',
    error5: 'Failed to create order',
  },
  dialog3: {
    title: 'Introduction to all-in-one machine',
    text1: '1. What is a cloud gaming all-in-one machine? ',
    text2: "Compared with traditional all-in-one monitors, the cloud gaming all-in-one machine has a high FPS refresh rate, achieving a smooth gaming experience. HKC Group's TIKEREN cloud gaming all-in-one machine is developed based on DeepBrainChain+DeepLink technology and can connect to remote high-performance GPU computing power in real time for game rendering and calculations. The all-in-one machine has a built-in Windows system and can be used for normal office and entertainment purposes. It can be streamed to other high-performance GPU hosts to play games through DeepLink. When you don't have a high-performance GPU host, you can connect to a remote high-performance GPU through DeepLink to play AAA games. You only need to pay a certain DLC Token every hour. ",
    text3: '2.TIKEREN all-in-one machine display',
    table: {
      th: {
        text1: 'Items',
        text2: '27 inches',
        text3: '31.5 inches',
      },
      td1: {
        text1: 'Mode Type',
        text2: 'MA27H13QC1',
        text3: 'MA27H13QC1'
      },
      td2: {
        text1: 'Color Category',
        text2: 'Black',
        text3: 'Black'
      },
      td3: {
        text1: 'Display Size',
        text2: '27 inches',
        text3: '31.5 inches'
      },
      td4: {
        text1: 'Aspect Ratio',
        text2: 'Wide (16:9)',
        text3: 'Wide (16:9)'
      },
      td5: {
        text1: 'Panel Type',
        text2: 'IPS',
        text3: 'VA'
      },
      td6: {
        text1: 'Panel Resolution',
        text2: 'QHD 2560*1440',
        text3: 'QHD 2560*1440'
      },
      td7: {
        text1: 'Panel Refresh Rate',
        text2: '180Hz (Max)',
        text3: '170Hz(Max)'
      },
      td8: {
        text1: 'Responese Time',
        text2: '1mS(MPRT) GTG 1ms',
        text3: '1ms(MPRT) GTG 1ms'
      },
      td9: {
        text1: 'Color Gamut',
        text2: 'DCIP3 90%',
        text3: 'DCIP3 90%'
      },
      td10: {
        text1: 'Mainboard Solution',
        text2: 'Intel® N100 Chipset',
        text3: 'Intel® N100 Chipset'
      },
      td11: {
        text1: 'CPU/Cooler',
        text2: 'Intel N100 3.4GHz',
        text3: 'Intel N100 3.4GHz'
      },
      td12: {
        text1: 'Memory',
        text2: 'DDR4 8GB(Option Max 32G)',
        text3: 'DDR4 8GB(Option Max 32G)'
      },
      td13: {
        text1: 'Hard Disk',
        text2: 'SSD 128G(Option Max 1T)',
        text3: 'SSD 128G(Option Max 1T)'
      },
      td14: {
        text1: 'OS',
        text2: 'Windows 10/11(0ption)',
        text3: 'Windows 10/11(0ption)'
      },
      td15: {
        text1: 'GPU',
        text2: 'Intel UHD Graphics',
        text3: 'Intel UHD Graphics'
      },
      td16: {
        text1: 'Rear Interface',
        text2: '1*DC Power Connector，1*RJ45(2.5G)，4* USB 3.0，1*Audio jacks',
        text3: '1*DC Power Connector，1*HDMIN，1*HDMI OUT，1*RJ45(2.5G)，4* USB 3.0,1*Audio iacks'
      },
      td17: {
        text1: 'Side Interface',
        text2: 'USB 2.0x2，Power Button x1',
        text3: 'USB 2.0x2，Power Button x1'
      },
      td18: {
        text1: 'Wi-Fi',
        text2: '2.4G~5GHz(Wi-Fi5)，BT(4.2)',
        text3: '2.4G~5GHz(Wi-Fi5)，BT(4.2)'
      },
      td19: {
        text1: 'Audio',
        text2: 'Built-in Speakers*2',
        text3: 'Built-in Speakers*2'
      },
      td20: {
        text1: 'Base/Stand',
        text2: 'HAS:VESA',
        text3: 'HAS:VESA'
      },
      td21: {
        text1: 'Pivot',
        text2: 'Up, down, left, right, 90° rotation, lift',
        text3: 'Up, down, left, right, 90° rotation, lift'
      },
      td22: {
        text1: 'Power',
        text2: '90W',
        text3: '90W'
      },
      td23: {
        text1: 'Game Screen lmprovement',
        text2: 'Free Sync, G-Sync',
        text3: 'Free Sync, G-Sync'
      }
    },
    btn: 'I got it'
  },
  dialog4: {
    title: 'Introduction to Cloud Game Handheld Console',
    text1: '1. What is a cloud gaming console? ',
    text2: "Compared with traditional handheld consoles, the cloud game console is developed based on DeepLink's ultra-low latency rendering technology. It can connect to the high-performance computing power of the cloud GPU server in real time for game rendering, thereby reducing the cost of the console by 70% and achieving Smooth 3A gaming experience. The built-in Google Play in the handheld device can download Android games, and you can also play games by streaming to your own other high-performance Windows GPU host/PS/XOBX. When you don’t have a high-performance GPU host, you can also connect to a remote high-performance GPU host through DeepLink to play AAA games. You only need to pay a certain amount of DLC Token every hour.",
    text3: '2. Blockchain cloud game handheld display',
    btn: 'I got it'
  },
  dialog5: {
    title: 'Introduction to Home GPU Gaming Mining Machine',
    text1: '1. What is a home GPU gaming miner?',
    text2: 'GPU gaming miner comes with NVIDIA 4070 Super GPU, Intel i7-13700F CPU, 32G memory, 2T SSD hard drive space, built-in DeepLink mining software and management system. Anyone can put this machine at home to earn DLC rewards, and there are 1 billion DLC Tokens are awarded to all game mining machines. Regardless of whether users rent machines to play games, they can get DLC rewards. When you set up a rental GPU game mining machine, you can get DLC rewards and DBC rental income. When there are no users renting it, you can also mine other tokens, which can generate income 24 hours a day.',
    text3: '2.Home GPU gaming mining machine display',
    text4: '3.Parameter introduction',
    text5_1: 'With RTX4070 Super Graphics Card',
    text5_2: 'Core i7-13700F, 16 Cores, 24 Threads, Base 1.5/2.1 GHz, Max 4.1/5.1GHz;',
    text5_3: 'Graphics Card GeForce RTX4070 Supe12G. Support 3rd Gen Ray Tracing and 4th Tensor Core.',
    text5_4: 'RAM Dual DDR4, Max 64GB (32GB*2).',
    text5_5: 'Hard Drive Ports One M2 2280 NVME SSD, and support to add double 2.5" SATA hard drive.',
    text5_6: 'Ports 4*USB 3.2, 4* USB 2.0, 3*DisplayPort, 1*HDMI, 2*LAN, 1*Optical, 1*Audio, 1*DC-IN, 2*WiFi ports.',
    text5_7: 'Operating System Preinstall with Windows 11 Pro.',
    btn: 'I got it'
  }
}